import React, { useState } from 'react';

const DEFAULT_IMAGE = 'https://via.placeholder.com/400x300?text=No+Image';

const RecipeImage = ({ imageUrl, alt, className, style }) => {
    const [error, setError] = useState(false);

    // Function to optimize Cloudinary URL
    const getOptimizedUrl = (url) => {
        if (!url) return DEFAULT_IMAGE;
        
        // Check if this is a Cloudinary URL
        if (url.includes('cloudinary.com') && url.includes('/upload/')) {
            // Insert optimization parameters but don't crop the image
            return url.replace('/upload/', '/upload/q_auto,f_auto/');
        }
        return url;
    };

    return (
        <img
            src={error ? DEFAULT_IMAGE : getOptimizedUrl(imageUrl)}
            alt={alt || "Recipe"}
            className={className}
            style={{
                width: '100%',
                height: 'auto',
                display: 'block',
                ...style
            }}
            onError={() => setError(true)}
        />
    );
};

export default RecipeImage; 